import { createContext, useContext } from "react";
import { User } from "firebase/auth";

export type LoginSuccessCallback = () => void;
export interface AuthContextType {
    user: User | null;
    claims: Record<string, any> | null;
    apiAuthenticated: boolean;
    activeSession: boolean;
    initialLoadComplete: boolean;
    loading: boolean;
    setLoading: (loading: boolean) => void;
    error: string | null;
    setError: (error: string | null) => void;
    logout: () => Promise<void>;
    loginWithEmail: (email: string, password: string) => Promise<User | null>;
    signUpWithEmail: (email: string, password: string) => Promise<User | null>;
    sendLoginLink: (email: string) => Promise<boolean>;
    completeLoginWithEmailLink: () => Promise<User | null>;
    completeLoginWithEmailLinkAndName: (name: string) => Promise<User | null>;
    loginWithGoogle: () => Promise<User | null>;
    loginWithGithub: () => Promise<User | null>;
    emailForSignIn: string | null;
    setEmailForSignIn: (email: string | null) => void;
    emailLinkSent: boolean;
    pendingAuthInfo: boolean;
    isAdmin: boolean;
    hasWorkspaceAccess: (workspaceId: string) => boolean;
    // Login modal state
    isLoginModalOpen: boolean;
    requireLogin: (onSuccess?: LoginSuccessCallback) => void;
    closeLoginModal: () => void;
    // Guest auth state
    guestUid: string | null;
    guestAuthInitialized: boolean;
    initializeGuestAuth: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function useAuth() {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
}
